<template>
  <ChartNormal
    size="12"
    offset="0"
    title="Arrival Date On Dock"
    chart="column"
    chartType="arrivalDate"
    :isCity="false"
    :withDate="true"
    :withFinancial="false"
    :arrivalDate="true"
  />
</template>

<script>
import ChartNormal from "../../../components/chart/chartNormal";

export default {
  name: "ArrivalDate",
  components: {
    ChartNormal
  }
};
</script>
